import type React from "react";
import { useState } from "react";
import styles from "./index.module.scss";

interface ButtonProps {
  label: string; // ボタンのラベル
  onClick?: () => void; // クリック時のイベントハンドラ
  type?: "button" | "submit" | "reset"; // ボタンのタイプ（デフォルトは 'button'）
  disabled?: boolean; // ボタンが無効化されているかどうか
  styleType?: string; // カスタムスタイルのタイプ
  heightType?: string;
  icon?: string;
  dataTestId?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  styleType = "primary",
  heightType = "",
  icon,
  dataTestId,
}) => {
  const [active] = useState(false);
  return (
    <button
      className={`${styles["button"]} ${styles[styleType]} ${styles[heightType]} ${active ? styles["is-active"] : ""}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {icon && <span className={`${styles["icon"]} ${styles[icon]}`} />}
      {label}
    </button>
  );
};

export default Button;
